export default "__VITE_ASSET__d5d8217b__"